/**
 * IntegrationsStep.jsx
 * ====================
 * Step for configuring integrations for static websites
 * Includes payment gateway, SEO, contact forms, WhatsApp, social media links
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';

const IntegrationsStep = () => {
  const { appName } = useParams();
  const [searchParams] = useSearchParams();
  const appType = searchParams.get('appType') || 'static';

  return (
    <SetupWizard currentStepKey="integrations">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        <h2 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '12px'
        }}>
          🔗 Configure Integrations
        </h2>
        <p style={{
          fontSize: '16px',
          color: '#6B7280',
          marginBottom: '32px'
        }}>
          Set up integrations for your static website: payment gateway, SEO, contact forms, WhatsApp messaging, and social media links.
        </p>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <div style={{
            padding: '20px',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            backgroundColor: '#F9FAFB'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '8px'
            }}>
              💳 Payment Gateway
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#6B7280',
              margin: 0
            }}>
              Integrate payment processing for your website. Coming soon.
            </p>
          </div>

          <div style={{
            padding: '20px',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            backgroundColor: '#F9FAFB'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '8px'
            }}>
              🔍 SEO Optimization
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#6B7280',
              margin: 0
            }}>
              Configure meta tags, sitemaps, and SEO settings. Coming soon.
            </p>
          </div>

          <div style={{
            padding: '20px',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            backgroundColor: '#F9FAFB'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '8px'
            }}>
              📝 Contact Forms
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#6B7280',
              margin: 0
            }}>
              Set up contact forms for your website. Coming soon.
            </p>
          </div>

          <div style={{
            padding: '20px',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            backgroundColor: '#F9FAFB'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '8px'
            }}>
              💬 WhatsApp Integration
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#6B7280',
              margin: 0
            }}>
              Add WhatsApp messaging functionality. Coming soon.
            </p>
          </div>

          <div style={{
            padding: '20px',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            backgroundColor: '#F9FAFB'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '8px'
            }}>
              📱 Social Media Links
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#6B7280',
              margin: 0
            }}>
              Add links to your social media profiles. Coming soon.
            </p>
          </div>
        </div>

        <div style={{
          marginTop: '32px',
          padding: '16px',
          backgroundColor: '#EFF6FF',
          borderRadius: '8px',
          border: '1px solid #BFDBFE'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#1E40AF',
            margin: 0,
            fontWeight: '500'
          }}>
            💡 Tip: You can configure these integrations later from the Integration page in your app dashboard.
          </p>
        </div>
      </div>
    </SetupWizard>
  );
};

export default IntegrationsStep;












